module.exports = __webpack_public_path__ + "img/stand_ruoyi_apple_cut.2884f6c1.png";